const API = process.env.VUE_APP_API;

export default API;
